import { createContext } from "react";

/**
 * Stands in for the quote of a citation that is still streaming. The block's markdown keeps this
 * placeholder while the quote grows, so the editor is not re-imported per token; the citation
 * reads the live quote from StreamingQuoteContext instead.
 */
export const STREAMING_QUOTE = "\uE000";

export const StreamingQuoteContext = createContext("");

/** Unescape the cited text of a `${A|E|D|H:id, start, end, "cited text"}` citation. */
export function decodeCitedText(raw: string): string {
    return raw
        .replace(/\\n/g, "\n")
        .replace(/\\t/g, "\t")
        .replace(/\\r/g, "")
        .replace(/\\"/g, '"')
        .replace(/\\\\/g, "\\");
}
